// extracted by mini-css-extract-plugin
export default {"dashboardNavCard":"GVjzxxIi"};